import { render, staticRenderFns } from "./BgqwPage18.vue?vue&type=template&id=bad4bb30"
import script from "./BgqwPage18.vue?vue&type=script&lang=js"
export * from "./BgqwPage18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports